import ClientQuickInfoButton from './ClientQuickInfoButton';

export default ClientQuickInfoButton;
